/**
 * Walk-mode player body width — scene field `playerWidth`, the creator setting next to
 * `playerHeight` ("Player Width" in the editor). It is the DIAMETER of the walker's
 * horizontal collision body in WORLD metres — the same at any splat scale (collision
 * stored in the splat's file space, e.g. voxels, converts it; see splatCollisionSpace);
 * CharacterController works with the radius (`collisionRadius` = width / 2).
 *
 * Pure (no PlayCanvas import) so the editor can share the default and bounds.
 */

/** Default width: the walker's historical hard-coded collision radius of 0.3. */
export const DEFAULT_PLAYER_WIDTH = 0.6;
export const MIN_PLAYER_WIDTH = 0.1;
export const MAX_PLAYER_WIDTH = 2;

/**
 * A creator-set player width, clamped to [MIN_PLAYER_WIDTH, MAX_PLAYER_WIDTH]. Anything that is
 * not a finite positive number (absent in older scenes, null, NaN, 0, a string) means the default.
 */
export function normalizePlayerWidth(width: unknown): number {
    if (typeof width !== 'number' || !Number.isFinite(width) || width <= 0) return DEFAULT_PLAYER_WIDTH;
    return Math.min(MAX_PLAYER_WIDTH, Math.max(MIN_PLAYER_WIDTH, width));
}

/** Walk collision radius (CharacterController `collisionRadius`) for a player width. */
export function playerCollisionRadius(width: unknown): number {
    return normalizePlayerWidth(width) / 2;
}
